import React from 'react'

function Noticias() {
  return (
    <div className='py-52 bg-blue-200'>Noticias</div>
  )
}

export default Noticias